import { render, staticRenderFns } from "./SingleColorPlanetSlide.vue?vue&type=template&id=1091b1b2"
import script from "./SingleColorPlanetSlide.vue?vue&type=script&lang=js"
export * from "./SingleColorPlanetSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1091b1b2')) {
      api.createRecord('1091b1b2', component.options)
    } else {
      api.reload('1091b1b2', component.options)
    }
    module.hot.accept("./SingleColorPlanetSlide.vue?vue&type=template&id=1091b1b2", function () {
      api.rerender('1091b1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/SingleColorPlanetSlide.vue"
export default component.exports